/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DevelopmentOnly/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DevelopmentOnly({
  children,
  viewPath = "/DesignSystem/DevelopmentOnly"
  
}) {
let constantData = fromHelpers.isDevelopment('helpers')
  return (<React.Fragment
>
<fromFlow.When is={constantData}>
<Children
  viewPath={`${viewPath}/Children`}
 data="'helpers'"
 format="helpers.js isDevelopment"
>
{children}
</Children>
</fromFlow.When>
</React.Fragment>)
}